import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import "./_style.scss";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { TkGetCodeList } from "../../utils/TkGetCode";
import { AasicItemYesNo, BenefitsKbn } from "../../assets/data/Constants";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC040004_01,
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "手当一覧",
  },
  {
    keyword: "info1",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC040004_02,
  },
  {
    title: "手当の一覧",
    keyword: "benefitsList",
    type: "text",
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: "申請手当名及び対応規程",
  },
  {
    keyword: "info2",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC040004_03,
  },
  {
    title: "申請手当名",
    keyword: "applyBenefitsName",
    type: "radioWithText",
    radioPropsList: TkGetCodeList(BenefitsKbn),
    inputProps: { maxLength: 30 },
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "対応規程",
    keyword: "parallelRule",
    type: "inputWithText",
    requiredIcon: true,
    outerTextLeft: "第",
    outerTextRight: "条",
    inputProps: { maxLength: 999 },
    disabled: true,
  },
  {
    title: "手当の支給金額の目安",
    keyword: "minAndMaxAmt",
    type: "limitInputGroup",
    requiredIcon: true,
    disabledMax: true,
    disabledMin: true,
  },
  {
    keyword: "title3",
    type: "lineTitle",
    lineTitle: "施設情報",
  },
  {
    keyword: "info3",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC040004_04,
  },
  {
    title: "対象施設",
    keyword: "targetFacilities",
    type: "checkboxGroup",
    requiredIcon: true,
    disabled: true,
  },
  {
    keyword: "title4",
    type: "lineTitle",
    lineTitle: "基本事項との対応",
  },
  {
    keyword: "info4",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC040004_05,
    explanatoryTextRule: "\\n",
  },
  {
    title: "条文",
    keyword: "article",
    type: "label",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "基本事項①：「負荷・困難度が高い業務に対して支給する」ことの表記",
    keyword: "checkBox1",
    type: "checkboxGroup",
    requiredIcon: true,
    checkBoxList: TkGetCodeList(AasicItemYesNo),
    disabled: true,
  },
  {
    title:
      "基本事項②：「業務負担が本俸額で見合わないため、その是正・調整目的で支給する」ことの表記",
    keyword: "checkBox2",
    type: "checkboxGroup",
    requiredIcon: true,
    checkBoxList: TkGetCodeList(AasicItemYesNo),
    disabled: true,
  },
  {
    title: "基本事項③：「支給対象となる業務内容」の具体的な表記",
    keyword: "checkBox3",
    type: "checkboxGroup",
    requiredIcon: true,
    checkBoxList: TkGetCodeList(AasicItemYesNo),
    disabled: true,
  },
  {
    title:
      "基本事項④：月額固定または、本俸に対する固定比率で、毎月支給することの表記",
    keyword: "checkBox4",
    type: "checkboxGroup",
    requiredIcon: true,
    checkBoxList: TkGetCodeList(AasicItemYesNo),
    disabled: true,
  },
  {
    keyword: "title5",
    type: "lineTitle",
    lineTitle: "給与規程",
  },
  {
    keyword: "info5",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC040004_06,
  },
  {
    title: "給与規程",
    keyword: "salaryRules",
    type: "fileUpload",
    requiredIcon: true,
  },
];
const schema = {
  applyBenefitsName: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  parallelRule: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0047E", "0"),
    },
    maxLength: {
      value: 3,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999"),
    },
  },
  minAndMaxAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
  },
  targetFacilities: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  article: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "500"),
    },
  },
  checkBox1: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  checkBox2: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  checkBox3: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  checkBox4: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  salaryRules: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};
const steps = [
  "「俸給の調整額」対象手当一覧",
  "「俸給の調整額」登録内容入力",
  "機構へ提出",
];
export { fakeTableList, schema, steps };
